import { useState } from "react";
import "./LocationSection.css";

function AccordionBlock({ emoji, title, items }) {
  const [open, setOpen] = useState(false);

  if (!title || !items?.length) return null;

  return (
    <div className={`location-accordion${open ? " open" : ""}`}>
      <button
        className="location-accordion__header"
        onClick={() => setOpen((o) => !o)}
      >
        <h4>{emoji} {title}</h4>
        <span className="location-accordion__icon">
          {open ? "−" : "+"}
        </span>
      </button>

      <div className="location-accordion__body">
        <div className="location-cards">
          {items.map((pt, i) => (
            <div key={i} className="location-card">
              <span className="location-card__pin">📍</span>
              <div className="location-card__info">
                <strong>{pt?.key}</strong>
                <span>{pt?.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function LocationSection({ location }) {

  // 🛑 CRITICAL FIX: prevent crash
  if (!location) return null;

  const {
    keyDistance,
    keyDistanceList,
    schoolDistanceTitle,
    schoolDistanceList,
    hospitalDistanceTitle,
    hospitalDistanceList,
    iframe
  } = location || {};

  const hasContent =
    keyDistance ||
    schoolDistanceTitle ||
    hospitalDistanceTitle;

  if (!hasContent && !iframe) return null;

  return (
    <section
      className="location-section section"
      aria-labelledby="location-heading"
    >
      <div className="container">
        <div className="location-section__grid">

          {/* Map */}
          {iframe && (
            <div className="location-map">
              <iframe
                src={iframe}
                title="Project location map"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          )}

          {/* Details */}
          <div className="location-details">

            {keyDistance && keyDistanceList?.length > 0 && (
              <div className="location-key">
                <h4 className="location-key__title">
                  💠 {keyDistance}
                </h4>

                <div className="location-cards">
                  {keyDistanceList.map((pt, i) => (
                    <div key={i} className="location-card">
                      <span className="location-card__pin">📍</span>
                      <div className="location-card__info">
                        <strong>{pt?.key}</strong>
                        <span>{pt?.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <AccordionBlock
              emoji="🎓"
              title={schoolDistanceTitle}
              items={schoolDistanceList}
            />

            <AccordionBlock
              emoji="🏥"
              title={hospitalDistanceTitle}
              items={hospitalDistanceList}
            />

          </div>
        </div>
      </div>
    </section>
  );
}